
import { Injectable } from '@angular/core';

import { ActionHandler } from '@app/core/components/actions/action.handler';

@Injectable()
export class MasterMasterGroupsFundosActions {
    constructor(
        private actionHandler: ActionHandler,
        
    ) {}



}